import { InlineEditableProperty } from "@/components/form/InlineEditableProperty"
import { contactEmailSchema, contactPhoneSchema } from "@/entities/user/user"

interface Props {
   user: {
      contactsEmails: string[]
      contactsPhones: string[]
   }
   onPropertySave: (field: string, value: any) => Promise<void>
}

export function YoungContactsForm({ user, onPropertySave }: Props) {
   return (
      <>
         <div className="divider mt-12 mb-10">Emails de contacts</div>

         <div className="space-y-4">
            <div className="space-y-2">
               {(user.contactsEmails || []).map((email, index) => (
                  <div key={index} className="flex items-center gap-2">
                     <InlineEditableProperty
                        label={`Email ${index + 1}`}
                        value={email}
                        field={`contactsEmails${index}`}
                        schema={contactEmailSchema}
                        onSave={(_field, value) => {
                           const newEmails = [...user.contactsEmails]
                           newEmails[index] = value
                           return onPropertySave("contactsEmails", newEmails)
                        }}
                        onDelete={() => {
                           const newEmails = [...user.contactsEmails]
                           newEmails.splice(index, 1)
                           onPropertySave("contactsEmails", newEmails)
                        }}
                     />
                  </div>
               ))}
               <form
                  onSubmit={(e) => {
                     e.preventDefault()
                     const input = e.currentTarget.querySelector("input") as HTMLInputElement
                     const newEmail = input.value.trim()
                     if (newEmail) {
                        const newEmails = [...(user.contactsEmails || []), newEmail]
                        onPropertySave("contactsEmails", newEmails)
                        input.value = ""
                     }
                  }}
                  className="flex gap-2"
               >
                  <input
                     type="email"
                     className="input input-bordered flex-grow"
                     placeholder="Nouvel email"
                  />
                  <button type="submit" className="btn _btn-ghost">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                     >
                        <path
                           fillRule="evenodd"
                           d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                           clipRule="evenodd"
                        />
                     </svg>
                     Ajouter
                  </button>
               </form>
            </div>
         </div>

         <div className="divider mt-12 mb-10">Téléphones de contacts</div>

         <div className="space-y-4">
            <div className="space-y-2">
               {(user.contactsPhones || []).map((phone, index) => (
                  <div key={index} className="flex items-center gap-2">
                     <InlineEditableProperty
                        label={`Téléphone ${index + 1}`}
                        value={phone}
                        field={`contactsPhones${index}`}
                        schema={contactPhoneSchema}
                        onSave={(_field, value) => {
                           const newPhones = [...user.contactsPhones]
                           newPhones[index] = value
                           return onPropertySave("contactsPhones", newPhones)
                        }}
                        onDelete={() => {
                           const newPhones = [...user.contactsPhones]
                           newPhones.splice(index, 1)
                           onPropertySave("contactsPhones", newPhones)
                        }}
                     />
                  </div>
               ))}
               <form
                  onSubmit={(e) => {
                     e.preventDefault()
                     const input = e.currentTarget.querySelector("input") as HTMLInputElement
                     const newPhone = input.value.trim()
                     if (newPhone) {
                        const newPhones = [...(user.contactsPhones || []), newPhone]
                        onPropertySave("contactsPhones", newPhones)
                        input.value = ""
                     }
                  }}
                  className="flex gap-2"
               >
                  <input
                     type="tel"
                     className="input input-bordered flex-grow"
                     placeholder="Nouveau numéro"
                  />
                  <button type="submit" className="btn">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                     >
                        <path
                           fillRule="evenodd"
                           d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                           clipRule="evenodd"
                        />
                     </svg>
                     Ajouter
                  </button>
               </form>
            </div>
         </div>
      </>
   )
}
